import React from "react";
import { IconCheck } from "../icons";
import "./scss/CheckBox.scss";
const CheckBox = ({ text, checked, onChange }) => {
  return (
    <div
      className={`ContainerCheckBox ${checked && "checked"}`}
      onClick={onChange}
    >
      <IconCheck />
    </div>
  );
};

export default CheckBox;
